<agr-page-toolbar
  [pageTitle]="'productionPurposeCategory.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'productionPurposeCategory.addProductionPurposeCategory' | translate"
  (primaryAction)="createProductionPurposeCategory()"
>
  <div class="container">
    <agr-notification-empty
      [isEmpty]="!dataAvailable"
      [emptyDescription]="'productionPurposeCategory.productionPurposeCategoryEmpty' | translate"
      emptyActionIcon="clear"
    >
      <mat-table [dataSource]="dataSource" data-test="production-purpose-table">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.name' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.name }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.description' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.description }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="n1">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.n1' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.n1 }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="n2">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.n2' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.n2 }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="n3">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.n3' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.n3 }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="baseYieldPotential">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.baseYieldPotential' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.baseYieldPotential }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nCorrection">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.nCorrection' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.nCorrection }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nO3NormTreshold">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.nO3NormTreshold' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.nO3NormTreshold }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="trendlineTuningA">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.trendlineTuningA' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.trendlineTuningA }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="trendlineTuningB">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.trendlineTuningB' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.trendlineTuningB }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="trendlineTuningC">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.trendlineTuningC' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.trendlineTuningC }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="trendlineTuningD">
          <mat-header-cell *matHeaderCellDef>{{
            'productionPurposeCategory.trendlineTuningD' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.trendlineTuningD }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2"></mat-header-cell>
          <mat-cell *matCellDef="let item" class="flex--justify-end flex__child flex__child-2">
            <agr-responsive-actions
              [items]="productionPurposeCategoryActions"
              [showLabels]="false"
              (action)="productionPurposeCategoryAction($event, item.id)"
            ></agr-responsive-actions>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          data-test="production-purpose-row"
        ></mat-row>
      </mat-table>
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
